import axiosApi, { setHeader } from "api/root.api";

export const publicProject = async (token, projectId) => {
  const urlEnd = `/scan/editor/project/v1/${projectId}/publish/public`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd);
  const result = response.data;
  return result;
};
